/**
 * @Author: ikoros
 * @Date:   2020-04-06T16:59:51+08:00
 * @Last modified by:   ikoros
 * @Last modified time: 2020-04-25T16:41:16+08:00
 */

import React from 'react';
import {render} from 'react-dom';

import 'babel-polyfill';

//import 'antd/dist/antd.css';
import './basic.less';
import './index.less';

import Main from './module';

render(
    <Main></Main>,
    document.getElementById('root')
);
